import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConDirectDeans: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConDirectDeanMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConDirectDeansRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConDirectDeans", null);
            } else {
                dispatch("receivingWebConDirectDeans"); // สถานะ กำลังบันทึก


                axios.get('/web_con_direct_deans', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConDirectDeans", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConDirectDeans", null);
                    });

            }
        },
        loadWebConDirectDeanRequest({dispatch}, id) {
            // We check if app runs with backend mode


            if (!config.isBackend) {
                dispatch("receiveWebConDirectDean", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConDirectDean");
                axios.get('/web_con_direct_deans/' + id).then(res => {
                    dispatch("receiveWebConDirectDean", res.data);
                })
            }
        },
        updateWebConDirectDeanRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConDirectDean");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('direct_dean_id', payload.direct_dean_id);
            formData.append('user_name', payload.user_name);
            formData.append('direct_dean_image', payload.direct_dean_image);
            formData.append('direct_dean_start_date', payload.direct_dean_start_date);
            formData.append('direct_dean_end_date', payload.direct_dean_end_date);
            formData.append('direct_dean_status_now', payload.direct_dean_status_now);
            formData.append('direct_dean_position_th', payload.direct_dean_position_th);
            formData.append('direct_dean_position_en', payload.direct_dean_position_en);
            formData.append('active', payload.active);
            axios.post('/update_con_direct_deans', formData).then(res => {
                dispatch("updateWebConDirectDean", res.data);
            })

        },
        createWebConDirectDeanRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConDirectDean");

            const formData = new FormData();

            formData.append('file', payload.avatarFile);
            // formData.append('direct_dean_id', payload.direct_dean_id);
            formData.append('user_name', payload.user_name);
            formData.append('direct_dean_image', payload.direct_dean_image);
            formData.append('direct_dean_start_date', payload.direct_dean_start_date);
            formData.append('direct_dean_end_date', payload.direct_dean_end_date);
            formData.append('direct_dean_status_now', payload.direct_dean_status_now);
            formData.append('direct_dean_position_th', payload.direct_dean_position_th);
            formData.append('direct_dean_position_en', payload.direct_dean_position_en);
            formData.append('active', payload.active);
            axios.post('/web_con_direct_deans', formData).then(res => {
                dispatch("receiveWebConDirectDean", res.data);

            })


        },
        deleteWebConDirectDeanRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConDirectDean", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConDirectDean", payload);

            axios.post('/delete_con_direct_deans', payload).then(res => {
                dispatch("deleteWebConDirectDean", {direct_dean_id: payload.direct_dean_id, res: res});
            })


        },
        receiveWebConDirectDeans({commit}, payload) {
            commit("RECEIVED_CONDIRECTDEANS", payload)
        },
        receivingWebConDirectDeans({commit}) {
            commit("RECEIVING_CONDIRECTDEANS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConDirectDean({commit}, payload) {
            commit("RECEIVED_CONDIRECTDEAN", payload)
        },
        receivingWebConDirectDean({commit}) {
            commit("RECEIVING_CONDIRECTDEANS") //call matutions --> state.isReceiving = true;
        },
        updateWebConDirectDean({commit}, payload) {
            commit("UPDATED_CONDIRECTDEAN", payload)
        },
        updatingWebConDirectDean({commit}) {
            commit("UPDATING_CONDIRECTDEAN") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConDirectDean({commit}, payload) {
            commit("DELETED_CONDIRECTDEAN", payload)
        },
        deletingWebConDirectDean({commit}, payload) {
            commit("DELETING_CONDIRECTDEAN", payload)
        },
        afterDeleteWebConDirectDean({commit}, payload) {
            commit("AFFTER_DELETED_CONDIRECTDEAN", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONDIRECTDEANS(state, payload) {

            state.webConDirectDeans = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONDIRECTDEANS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONDIRECTDEAN(state, payload) {


            if (payload.direct_dean_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConDirectDeanMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConDirectDeanMessage: (state.webConDirectDeanMessage == webConDirectDeanMessage ? webConDirectDeanMessage + ' ' : webConDirectDeanMessage),

                });
            } else {
                let webConDirectDeanMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConDirectDeans: [...state.webConDirectDeans, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConDirectDeanMessage: (state.webConDirectDeanMessage == webConDirectDeanMessage ? webConDirectDeanMessage + ' ' : webConDirectDeanMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },

        UPDATED_CONDIRECTDEAN(state, payload) {

            let index = state.webConDirectDeans.findIndex(p => p.direct_dean_id === payload.direct_dean_id);
            let webConDirectDeanMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConDirectDeans: state.webConDirectDeans.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConDirectDeanMessage: (state.webConDirectDeanMessage == webConDirectDeanMessage ? webConDirectDeanMessage + ' ' : webConDirectDeanMessage),
            })
        },
        UPDATING_CONDIRECTDEAN(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONDIRECTDEAN(state, payload) {


            if (payload.direct_dean_id == undefined || payload.res.data.message == 'Relation') {
                let webConDirectDeanMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.direct_dean_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConDirectDeanMessage: (state.webConDirectDeanMessage == webConDirectDeanMessage ? webConDirectDeanMessage + ' ' : webConDirectDeanMessage),

                });
            } else {
                let indexToDelete = state.webConDirectDeans.findIndex(p => p.direct_dean_id === payload.direct_dean_id);
                let webConDirectDeans = [...state.webConDirectDeans];
                webConDirectDeans.splice(indexToDelete, 1);
                let webConDirectDeanMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConDirectDeans: [...webConDirectDeans],
                    isDeleting: false,
                    idToDelete: null,
                    webConDirectDeanMessage: (state.webConDirectDeanMessage == webConDirectDeanMessage ? webConDirectDeanMessage + ' ' : webConDirectDeanMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONDIRECTDEAN(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.direct_dean_id;
        },
        AFFTER_DELETED_CONDIRECTDEAN(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
